import InternalAppSchema, { EventNode, EventType } from './InternalAppSchema'

const createEventType = (
  type: EventType,
  name?: string,
  customKeys: EventNode = {},
): InternalAppSchema => ({
  event: {
    type,
    name,
    ...customKeys,
  },
})

export default createEventType
